import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, IconGoogle } from "../../../components/atoms";
import { FlatpickerGroup, SelectGroup } from "../../../components/molecules";
import { Pagination } from "../../../components/organisms";
import { TableTour } from "../../../components/organisms/TableTour";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import { ConsultaTourContext } from "../../../contexts/ConsultaTour/ConsultaTourContext";
import { api } from "../../../helpers";
import { useApi } from "../../../hooks/useApi";

import * as S from "./styles";

export function Tours() {
  const navigate = useNavigate();
  const { applicationData, user } = useContext(AuthContext);
  const { passeio, setPasseio } = useContext(ConsultaTourContext);
  const apiHook = useApi();
  const [permissions, setPermissions] = useState({
    passeioinc: true,
    relrecibo: false,
  });

  const [paginationControl, setPaginationControl] = useState<PaginationType>({
    offset: 0,
    limit: 500,
    count: 0,
  });

  useEffect(() => {
    if (passeio.dataInicial && passeio.dataFinal && !passeio.jaConsultou) {
      //      console.log("entrou effect");
      consultar();
      //      debugger;
      setPasseio((current) => ({
        ...current,
        jaConsultou: true,
      }));
    }
  }, [paginationControl.limit, paginationControl.offset]);

  const consultar = async () => {
    const {
      data: { TotalRegistros, Registros },
    } = await api.post("/api/passeios/search", {
      vempresa: "7",
      vdestino: passeio.destino,
      vbarco: passeio.barco,
      vdataInicial: passeio.dataInicial,
      vdataFinal: passeio.dataFinal,
      limit: paginationControl.limit,
      offset: paginationControl.offset,
    });

    if (TotalRegistros > 0) {
      const convertingDataToDisplay = (registros: any) =>
        registros.map((registro: any) => {
          return {
            ...registro,
          };
        });

      setPaginationControl((current) => ({
        ...current,
        count: TotalRegistros,
      }));
      const convertedDataForDisplay = convertingDataToDisplay(Registros);
      setPasseio((current) => ({
        ...current,
        data: convertedDataForDisplay,
      }));
    }
  };

  const ignoreButtons =
    applicationData.passeioinc === false && applicationData.relrecibo === true;
  //  console.log(passeio);
  return (
    <div>
      <h2>Passeios</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={passeio.destino}
            id="destino"
            label="Destino"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo,
            }))}
            onChange={(e) => {
              setPasseio((current) => ({
                ...current,
                destino: e.target.value,
              }));
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={passeio.barco}
            id="barco"
            label="Barco"
            options={applicationData.barcos.map((barco: Barco) => ({
              text: barco.nome,
              value: barco.codigo,
            }))}
            onChange={(e) => {
              setPasseio((current) => ({
                ...current,
                barco: e.target.value,
              }));
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <FlatpickerGroup
            label="Data Inicial"
            value={passeio.dataInicial}
            id="data-ini"
            onChange={([date]) => {
              setPasseio((current) => ({
                ...current,
                dataInicial: date,
              }));
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <FlatpickerGroup
            label="Data Final"
            value={passeio.dataFinal}
            id="data-fim"
            options={{ minDate: "today" }}
            onChange={([date]) => {
              setPasseio((current) => ({
                ...current,
                dataFinal: date,
              }));
            }}
          />
        </div>

        <div className="row mt-3"></div>

        <S.ButtonWrapper>
          {!ignoreButtons && (
            <Button
              appearance="primary"
              onClick={() => {
                navigate("/cadastros/passeios/new");
              }}
            >
              Novo<IconGoogle>add</IconGoogle>
            </Button>
          )}

          <Button
            appearance="secondary"
            onClick={() => {
              setPasseio((current) => ({
                ...current,
                jaConsultou: true,
              }));
              consultar();
            }}
          >
            Consultar<IconGoogle>manage_search</IconGoogle>
          </Button>
        </S.ButtonWrapper>

        <TableTour
          data={passeio.data}
          onClick={(data) => {
            setPasseio({
              ...passeio,
              data,
            });
          }}
          ignoreButtons={ignoreButtons}
        ></TableTour>

        {passeio.data.length > 0 && (
          <Pagination
            className="col-12"
            data={paginationControl}
            dispatch={(event) => {
              setPasseio((current) => ({
                ...current,
                jaConsultou: false,
              }));
              setPaginationControl(event);
            }}
          />
        )}
      </div>
    </div>
  );
}
